var _defs, _rect, _path, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationLightTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1410,
    height: 1420.23,
    viewBox: "0 0 1410 1420.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 429.77,
    y: 461.17,
    width: 119.73,
    height: 216.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.5,614.84l-8,9,85,54-2.5-39.5c-7-2-9.5-4-14-9.5-6.63-8.1-8.33-30.5-8-41,5.24,1,7.46,1.41,10.18,1.3,6.73-.26,12.09-5.9,12.72-12.61,5.31-56.22-15.39-97-22.9-102.19-8-5.5-10.5-14.5-39-13s-53,23.5-56,60.5,24,51,37.5,61.5C478.3,591.74,475.33,607.84,472.5,614.84Z",
    fill: "#fcd6bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 505.47,
    y1: 3557.16,
    x2: 505.47,
    y2: 3514.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 4132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9bb90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9bb90",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -2.39,
    width: 1410,
    height: 1420.23,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.45,917.32c-26.74,42-42.43,88.39-62.38,132.38-16.62,36.64-38.76,72-54.79,108.58,0,10.59-5.77,23.61,7.21,30.09,15.74,7.87,28.21,24.8,32.37,38.1,2.83,9,6,14.13,17.56,18.86,28,11.39,64.38,16.46,95.29,21,74.86,10.88,152,16.93,228.19,20.29,76.46,3.36,153.31,2,229.88,2,22.9,0,45.41.27,68.16-1.91C816.42,1280,886,1271.59,955.64,1261c88.25-13.43,174.24-33.1,260.56-51.82,39.87-8.64,79.69-17.89,119.8-25.9,24.07-4.81,29.86-22.72,40.1-37.91,23.35-34.6,16.65-80.22,32.51-117.52s18.75-81.58-15.21-114.48c-24.23-23.48-56.61-49.6-89.91-66.29-56.25-28.18-70.29-55.81-97.9-101.14a787.86,787.86,0,0,0-55-79.43c-21.11-26.56-44.44-55-73.53-77.34-37-28.35-125.11-62-186-62.24-112-.42-163.83,2.64-273.09,22-55.11,9.79-118.19,14.61-167.24,35.15-38.25,16-80.14,34.5-99.48,64.47-34.67,53.75-69.17,97-78.51,158.1C267.53,840.22,204.87,885.22,184.45,917.32Z",
    fill: "#f7f8f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 1087.84,
    width: 1410,
    height: 330,
    fill: "#d5d8da"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 1133.84,
    width: 406,
    height: 119,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 1282.84,
    width: 406,
    height: 135,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 1133.84,
    width: 406,
    height: 119,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 1193.84,
    r: 12,
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945,
    y: 1133.84,
    width: 406,
    height: 119,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 1282.84,
    width: 406,
    height: 135,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945,
    y: 1282.84,
    width: 406,
    height: 135,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 1193.84,
    r: 12,
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 1349.84,
    r: 12,
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 1349.84,
    r: 12,
    fill: "#f7f8f8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 871.84,
    width: 168,
    height: 216,
    fill: "#d5d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,871.84H410L401,953a10,10,0,0,1-9.94,8.89H261a10,10,0,0,1-9.94-8.89Z",
    fill: "#eef0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,1087.84H410l-7.28-15.3a10,10,0,0,0-9-5.7H258.31a10,10,0,0,0-9,5.7Z",
    fill: "#f3f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 888.34,
    r: 7.5,
    fill: "#d5d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,1066.84c.33-17.5,3.9-57.7,15.5-78.5H366c8.5,18,14,57.67,15.5,78.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.08,1053l-11.72-54.57,6-.74c7.68-1,18.36.18,25.3,6.3,4.5,4,6.88,9.57,6.88,16.18,0,19.22-13.5,28.65-20.63,31Zm1.69-44.51,6.21,28.9c3.55-3,7.52-8.28,7.52-17.22,0-3.46-1-6-3.16-7.93-2.57-2.27-6.58-3.42-10.57-3.75Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M891,864.34c-8.4-1.2-13.83.5-15.5,1.5l-7.5,16,10.5,9,48.5,55c-1,3.17-3,10-3,12s2,3.5,3,4c6.33-6.83,19.4-21.5,21-25.5,2-5,5.5-41,3.5-45.5S901.5,865.84,891,864.34Z",
    fill: "#fcd6bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,1043.2c1.8-4,3.61-8.09,5.59-12,4.45-8.92,8.78-20.21,10.62-29.89a20.33,20.33,0,0,1,3.43-4.61c.89-.84,1.78-2.08,3-2.42a12.05,12.05,0,0,1,3.06-.06c2.22,0,4.66-.23,6.82.32,2.95.77,10-4.16,8.5-1.16-2,4-7.51,12.94-7.51,16.44,0,2.61-.43,5.65.06,8.23.81,4.23,2.91,9,4.41,13.12,2,5.36,3.63,10.92,5.83,16.18a77.59,77.59,0,0,1,3.41,8.72c.66,2.39,1.37,4.7,2.16,7a77.91,77.91,0,0,0,5.07,11.4,21.41,21.41,0,0,0,5.22,7,15.57,15.57,0,0,0,9.29,3c1,0,3-.62,3.92-.21.21.1,1,.18,1,.38a10,10,0,0,1,0,2.57,8.92,8.92,0,0,1-1.18,3.23c-2.23,3.47-5.94,5.41-10.07,4.38-4.36-1.09-8.9-1.18-13-3a12.5,12.5,0,0,1-5-3.93c-1.31-1.52-1.52-4.43-2.36-6.26-2-4.26-3.21-8.7-5.13-13a10.27,10.27,0,0,0-4.58-5,5.41,5.41,0,0,0-4.93.4c-4.94,3.36-8.77,8.25-13.43,12-8.93,7.25-20,13.3-31.21,15.79-5.76,1.28-11.64,1.57-17.31,3.07a62.61,62.61,0,0,1-16.28,2.18,38.81,38.81,0,0,1-9.89-1.25c-2.07-.52-4.07-6.39-4.19-8.19,1.65-3.27,13.16-3.85,15.65-4.27,1.89-.29,13.49-4.23,15.33-4.69a42.72,42.72,0,0,0,5.23-2.18,58.32,58.32,0,0,0,11-5.65c3.29-2.19,5.57-3.44,8-6.42C257.08,1058.29,258.26,1050.38,261.46,1043.2Z",
    fill: "#fcd6bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739,934.84c31.2-16.4,117-40.83,156-51l-53.5,65.5L665,1088.84c-32.67-38.33-97-115.1-93-115.5,5-.5,57.5-19.5,60.5-18,2.4,1.2,2.67,4.84,2.5,6.5,3-.66,9.7-1.8,12.5-1s4.17,4.34,4.5,6c4.17-3.5,13.5-10.6,17.5-11s7.33,3.17,8.5,5C685.33,959,707.8,951.24,739,934.84Z",
    fill: "#003f6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758,976.84c22-23.2,84.5-65.33,113-83.5l24-9.5c8-.83,25.7,3.2,32.5,26,8.5,28.5,0,45.5-21,67-16.8,17.2-162.33,105.17-233,147l-33-16.5C670.5,1073.51,736,1000,758,976.84Z",
    fill: "#004672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,1047.34c0-27,6.5-44.5,14-70.5l32.5-29,86.5,23.5c2.67,1.17,12.2,12.2,15,15,3,6.5,7.5,17,3,26,24,25,193.76,214,199.5,248.5,3.2,19.2-3.33,241-7,349.5-16-67-49.7-210.3-56.5-247.5s-2.83-66.17,0-76C652.33,1218,459,1114.42,459,1047.34Z",
    fill: "#266287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,685.84c-16.8-24-32.33-32.66-38-34l13.5,164.5c15.17,20.67,48.1,63.6,58.5,70s144.67,5.67,210.5,4.5l10-28c-35.67-5.83-111.6-18.5-130-22.5s-47.67-5.33-60-5.5C675,795.18,641.8,709.84,625,685.84Z",
    fill: "#b3d7ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,976.84l-45.5-170-31.5-162c23.17-7.5,77.3-21.4,108.5-17,39,5.5,99,11,118,70.5,15.2,47.6-4.33,186.5-4.5,260.5-11,6-18,11.5-42.5,15.5C553.38,978,480.83,974,473,976.84Z",
    fill: "#4da3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,612.34l59,3.5,16.5,33L491,634.34l-36.5-13Z",
    fill: "#0073bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5,814.84c13.6-44,54-131.66,72.5-170,9.5-2.5,9.5-2.5,27,0h0c44.76,6.4,40.5,101,6,158.5-27.6,46-95.5,146.5-126,191a62.78,62.78,0,0,1-14,7,19.34,19.34,0,0,1-13,0C286.17,957.51,309.9,858.84,323.5,814.84Z",
    fill: "#b3d7ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.5,614.84l-8,9,85,54-2.5-39.5c-7-2-9.5-4-14-9.5-6.63-8.1-8.33-30.5-8-41,5.24,1,7.46,1.41,10.18,1.3,6.73-.26,12.09-5.9,12.72-12.61,5.31-56.22-15.39-97-22.9-102.19-8-5.5-10.5-14.5-39-13s-53,23.5-56,60.5,24,51,37.5,61.5C478.3,591.74,475.33,607.84,472.5,614.84Z",
    fill: "#fcd6bc"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.5,580.84c10,3.6,23.83,6.17,29.5,7l4,13c1.17,5.67.7,17-10.5,17s-29.33-28.66-37-43C482,575.34,485.5,577.24,495.5,580.84Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414,631.84c1.6-3.6,6-4.5,8-4.5,11.33,0,37.6.9,52,4.5s59,33,75.5,46c1.5-6.16,2.5-21,2.5-27,0-5.33-3-17-3-22,.5-.5,2.2-.9,5,1.5,3.5,3,2.11,14.12,1.5,22-.5,6.5-3.17,20.34-6,25.5-19.83-8.5-69.8-29-79-33s-35.83-6.66-48-7.5l-6,1.5A5.42,5.42,0,0,1,414,631.84Z",
    fill: "#268fca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.5,618.84c8,1.5,27.3,6.3,40.5,13.5s40.33,35.34,47.5,45.5c.5-6.5-8.3-27.5-9.5-35.5s-8.5-21.16-12-26.5a3.85,3.85,0,0,1,2-4c2-1.2,6.17,1.17,8,2.5,3.67,2.34,11,8.6,11,15,0,3.81,3.5,11.5,3,27.5a79.12,79.12,0,0,1-2.5,21c-10.33-8-45.5-31.9-65.5-39.5s-48-9.16-59.5-9c-1.33-.66-3.7-2.5-2.5-4.5,1.5-2.5,20.5-14.5,33-14.5,6.8,0,14.83-1,19-.5l-1.5,5Z",
    fill: "#80bde0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.69,454.26a15.5,15.5,0,0,0-30.1-1.17,15.5,15.5,0,0,0-15.91,2.26,18,18,0,0,0-28,19.54h-1.22a15.5,15.5,0,0,0-13.92,22.32,6.52,6.52,0,0,0-2.58,5.18v.78a15.51,15.51,0,0,0,8,24.07v.65a11,11,0,0,0,5.14,9.31,11,11,0,0,0,5,18.32,15.5,15.5,0,0,0,11,12.74,6.09,6.09,0,0,0-.1,1.13,6.51,6.51,0,0,0,11,4.69v.31a5.5,5.5,0,1,0,10.28-2.73,6.5,6.5,0,0,0-2.74-11.7,15.6,15.6,0,0,0,1.46-6.59,15.35,15.35,0,0,0-2.41-8.3,15.52,15.52,0,0,0-2.49-21.81,15.3,15.3,0,0,0-3.72-2.19,11,11,0,0,0,2.62-12.8,15.53,15.53,0,0,0,7-11.79,9.48,9.48,0,0,0,2.54.34,9.65,9.65,0,0,0,4.46-1.1,6.5,6.5,0,0,0,12-3.4v-.51a15.5,15.5,0,0,0,20-9,16.94,16.94,0,0,0,.62-2.07,6.51,6.51,0,0,0,3.9-2.27,6.5,6.5,0,0,0,9.12-1.16h0l.12-.16a12.41,12.41,0,0,0,7.74,2.68,6.5,6.5,0,1,0,11-6.61,12.5,12.5,0,0,0-19.2-15.33A9.54,9.54,0,0,0,504.69,454.26Z",
    fill: "#424e54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.21,527.35c5.55-2,10.4,2.56,12.13,5.12L466,560.61c-2.31.57-8.83.34-16.46-5.12C440,548.69,438.29,529.91,445.21,527.35Z",
    fill: "#fcd6bc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1142,
    y: 866.84,
    width: 3,
    height: 68,
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1034,
    y: 1017.84,
    width: 216,
    height: 400,
    fill: "#b9bfc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.67,850.77c-28.07-44.72,33.18-61.24,19.82-2.71Z",
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.85,841.3c35.89-33.28,61.51,19.64,5.9,17.59Z",
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.27,856.09c48.5,6.56,23.92,60-9.83,15.73Z",
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.81,866.92c6.76,48.47-51.31,39.19-17.79-5.23Z",
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.87,866.66c-48.1,9-41.54-49.42,4.4-18Z",
    fill: "#e2e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1142.5,
    cy: 856.34,
    r: 13.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.5,934.85c5.67-15.17,26.4-45.4,64-45C1209.5,930.85,1179,931.35,1142.5,934.85Z",
    fill: "#e9ecec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143,934.84c-4.68-12.47-21.79-37.32-52.83-37C1087.69,931.55,1112.87,932,1143,934.84Z",
    fill: "#e9ecec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198,931.84H1087l16.5,86H1180Z",
    fill: "#b9bfc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090,1008.84l9,9h87l9-9Z",
    fill: "#d5d8da"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M851,636V406.28a9.93,9.93,0,0,0-7.75-9.71c-64-14.36-120.45-20.2-191.74-20.69a10,10,0,0,0-10,10v235a10,10,0,0,0,10,10c61.88.27,126.24,3.26,187.39,15a10.15,10.15,0,0,0,11.91-8h0A9.91,9.91,0,0,0,851,636Z",
    fill: "#9cdb90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851,710V691.27a9.72,9.72,0,0,0-7.14-9.46A290.89,290.89,0,0,0,777,672.49a9.78,9.78,0,0,0-10,9.56h0V698.7a10,10,0,0,0,9.64,10c22.31.86,44.93,2.16,66.72,7.21a6.21,6.21,0,0,0,7.47-4.6h0A6.44,6.44,0,0,0,851,710Z",
    fill: "#39b620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.81,616.33c21.89-6,52.69-14.23,52.69-20.49v157c0,8.64-28.67,11.3-48.67,13.27a10.3,10.3,0,0,1-11.28-9.22v0h0V625.94A9.94,9.94,0,0,1,941.81,616.33Z",
    fill: "#b3e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.12,579.51c39.8-4.93,102.38-14.53,102.38-22.17v-71c0,22.06-63.89,29.48-103.61,30.79A10.18,10.18,0,0,0,905,527.26v42.35a9.89,9.89,0,0,0,9.78,10h.07A7.68,7.68,0,0,0,916.12,579.51Z",
    fill: "#b3e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878,717.69V569.61a9.7,9.7,0,0,1,9.57-9.83h0a11.69,11.69,0,0,1,1.56.11c31.09,4.72,105.37,18.52,105.37,35.93v157c0-14.64-78.13-22.58-107.39-25.2A10,10,0,0,1,878,717.69Z",
    fill: "#9cdb90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.5,525.47V462.73a9.52,9.52,0,0,1,13.85-8.7c17,8.89,36.15,21.6,36.15,32.81v70.5c0-6.29-25.45-16.34-43-22.23A10.21,10.21,0,0,1,968.5,525.47Z",
    fill: "#9cdb90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,437.34v-26.2a5,5,0,0,1,5-5h.28c39.86,2.23,104.13,5.16,158.41,17.79a5,5,0,0,1,3.82,4.84v25a5,5,0,0,1-6,4.92c-49.21-9.55-100.29-15.94-156.52-16.3a5,5,0,0,1-5-5Z",
    fill: "#c4e9bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,484.61V458a5,5,0,0,1,5-5h.12c59,1.56,104.31,5.55,158.51,18a5,5,0,0,1,3.87,4.86v26a5,5,0,0,1-5,5h0a4.18,4.18,0,0,1-.93-.08c-51-9.08-100.5-14.26-156.83-17.19A5,5,0,0,1,665,484.61Z",
    fill: "#c4e9bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,532.61V506.14a5,5,0,0,1,5-5h.28c39.85,2.19,104.1,4.66,158.37,16.82a5,5,0,0,1,3.86,4.85V547a5,5,0,0,1-5,5,4.76,4.76,0,0,1-.84-.07c-51-8.08-100.56-11.48-156.92-14.32A5,5,0,0,1,665,532.61Z",
    fill: "#c4e9bc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLightTheme);
export default __webpack_public_path__ + "static/media/illustration-light-theme.cb4a509626ad69f744fa13bbc2cfb4d3.svg";
export { ForwardRef as ReactComponent };